module.exports = __webpack_public_path__ + "img/undraw_Add_files_re_v09g.a298efb3.svg";